import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

interface PageContainerProps {
  children: ReactNode;
  /** Max content width. Defaults to a comfortable reading width. */
  maxWidth?: number | string;
  sx?: SxProps<Theme>;
}

/**
 * Consistent page shell: centered, responsive horizontal padding that is
 * generous on desktop and tight on phones, plus safe-area padding at the
 * bottom so content clears the mobile bottom navigation.
 */
const PageContainer = ({ children, maxWidth = 1120, sx }: PageContainerProps) => (
  <Box
    sx={{
      width: '100%',
      maxWidth,
      mx: 'auto',
      px: { xs: 1.75, sm: 3 },
      pt: { xs: 1.5, sm: 2.5 },
      pb: { xs: 'calc(96px + env(safe-area-inset-bottom))', sm: 5 },
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default PageContainer;
